export const subtiposDish = [
  "pastas",
  "ensaladas",
  "carnes",
  "pescados y mariscos",
  "sopas",
  "minutas",
  "arroz",
  "sandwich",
];
export const volumeDrink = [
  "250ml",
  "355ml",
  "473ml",
  "500ml",
  "750ml",
  "1000ml",
  "1500ml",
];
export const typeDrink = ["cerveza", "vino", "agua", "gaseosa"];
